<div class="row" *ngIf="!flag">
    <div class="col-md-12">
        <span>Sorry,something went wrong. Please try again.</span>
    </div>
</div>
<div class="row" *ngIf="flag">
    <div class="col-md-12">
        Error Message : {{errorMessage}}
    </div>
</div>
